<div class="plan-usage-container mat-typography mat-body">

  <div class="card-wrapper">
    <!-- Low Starts -->
    <div class="card-col">
      <div class="usage-box box-low" [ngClass]="selectedUsageCode === templateUsageCodeByUsageLevel.LOW ? 'plan-selected' : ''">
        <div class="primary-content">
          <h1>
            <slot name="low_h1">Have a Medicare advisor reach out to you.</slot>
          </h1>
          <p>
            <slot name="low_p">I see my doctor or specialist about once a month. I might visit the hospital sometimes.</slot>
          </p>
          <div class="btn-wrapper">
            <button mat-raised-button color="primary" (click)="selectPlan($event, templateUsageCodeByUsageLevel.LOW)">
              <slot name="low_btn">LOW</slot>
            </button>
          </div>

          <div class="view-more-less" (click)="toggleViewMoreLess($event, templateUsageCodeByUsageLevel.LOW)">
            @if (viewMore[1] === false) {
              <span>
                <slot name="low_read_more">READ MORE</slot>
              </span>
            }
            @if (viewMore[1] === true) {
              <span>
                <slot name="low_view_less">VIEW LESS</slot>
              </span>
            }
            <span class="more-less-icon">
              @if (viewMore[1] === false) {
                <span class="material-symbols-outlined">keyboard_arrow_down</span>
              }
              @if (viewMore[1] === true) {
                <span class="material-symbols-outlined">keyboard_arrow_up</span>
              }
            </span>
          </div>
        </div>
        @if (viewMore[1] === true) {
          <div class="more-content">
            <div class="list">
              <ul>
                <li>
                  <slot name="low_li_1">I want a lower monthly premium, even if I pay more when I visit my doctor ot go to the hospital</slot>
                </li>
                <li>
                  <slot name="low_li_2">I want a defined network of doctors and hospitals if it reduces my costs</slot>
                </li>
                <li>
                  <slot name="low_li_3">I take only a few prescriptions (0-2 total)</slot>
                </li>
              </ul>
            </div>
          </div>
        }
      </div>
    </div>
    <!-- LOW Ends -->

    <!-- MODERATE Starts -->
    <div class="card-col">
      <div class="usage-box box-moderate" [ngClass]="selectedUsageCode === templateUsageCodeByUsageLevel.MODERATE ? 'plan-selected' : ''">
        <div class="primary-content">
          <h1>
            <slot name="moderate_h1">I Need Moderate Medicare Care</slot>
          </h1>
          <p>
            <slot name="moderate_p">
              I see a doctor or specialist several times each month.
              I might visit the hospital several times this year.
            </slot>
          </p>
          <div class="btn-wrapper">
            <button mat-raised-button color="primary" (click)="selectPlan($event, templateUsageCodeByUsageLevel.MODERATE)">
              <slot name="moderate_btn">MODERATE</slot>
            </button>
          </div>
          <div class="view-more-less" (click)="toggleViewMoreLess($event, templateUsageCodeByUsageLevel.MODERATE)">
            @if (viewMore[2] === false) {
              <span>
                <slot name="moderate_read_more">READ MORE</slot>
              </span>
            }
            @if (viewMore[2] === true) {
              <span>
                <slot name="moderate_view_less">VIEW LESS</slot>
              </span>
            }
            <span class="material-icons more-less-icon">
              @if (viewMore[2] === false) {
                <span>keyboard_arrow_down</span>
              }
              @if (viewMore[2] === true) {
                <span>keyboard_arrow_up</span>
              }
            </span>
          </div>
        </div>
        @if (viewMore[2] === true) {
          <div class="more-content">
            <div class="list">
              <ul>
                <li>
                  <slot name="moderate_li_1">I want a lower monthly premium, even if I pay more when I visit my doctor ot go to the hospital</slot>
                </li>
                <li>
                  <slot name="moderate_li_2">I want a defined network of doctors and hospitals if it reduces my costs</slot>
                </li>
                <li>
                  <slot name="moderate_li_3">I take only a few prescriptions (0-2 total)</slot>
                </li>
              </ul>
            </div>
          </div>
        }
      </div>
    </div>
    <!-- MODERATE Ends -->

    <!-- HIGH Starts -->
    <div class="card-col">
      <div class="usage-box box-high" [ngClass]="selectedUsageCode === templateUsageCodeByUsageLevel.HIGH ? 'plan-selected' : ''">
        <div class="primary-content">
          <h1>
            <slot name="high_h1">I Need High Medicare Care</slot>
          </h1>
          <p>
            <slot name="high_p">
              I see a doctor or specialist several times each month. I have varying types of appointments,
              and may have a chronic condition or need frequent diagnostic tests.
            </slot>
          </p>
          <div class="btn-wrapper">
            <button mat-raised-button color="primary" (click)="selectPlan($event, templateUsageCodeByUsageLevel.HIGH)">
              <slot name="high_btn">HIGH</slot>
            </button>
          </div>
          <div class="view-more-less" (click)="toggleViewMoreLess($event, templateUsageCodeByUsageLevel.HIGH)">
            @if (viewMore[3] === false) {
              <span>
                <slot name="high_read_more">READ MORE</slot>
              </span>
            }
            @if (viewMore[3] === true) {
              <span>
                <slot name="high_view_less">VIEW LESS</slot>
              </span>
            }
            <span class="material-icons more-less-icon">
              @if (viewMore[3] === false) {
                <span>keyboard_arrow_down</span>
              }
              @if (viewMore[3] === true) {
                <span>keyboard_arrow_up</span>
              }
            </span>
          </div>
        </div>
        @if (viewMore[3] === true) {
          <div class="more-content">
            <div class="list">
              <ul>
                <li>
                  <slot name="high_li_1">I want a lower monthly premium, even if I pay more when I visit my doctor ot go to the hospital</slot>
                </li>
                <li>
                  <slot name="high_li_2">I want a defined network of doctors and hospitals if it reduces my costs</slot>
                </li>
                <li>
                  <slot name="high_li_3">I take only a few prescriptions (0-2 total)</slot>
                </li>
              </ul>
            </div>
          </div>
        }
      </div>
    </div>
    <!-- HIGH Ends -->
  </div>

  <div class="button-container">
    <button mat-raised-button color="primary" (click)="nextClicked($event)" [disabled]="!selectedUsageCode">
      <span>Next</span>
    </button>
  </div>

</div>
